import { render } from "./App.vue?vue&type=template&id=1a4f0d00"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
script.render = render

export default script